// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ReportPollingController from "./report_polling_controller";
application.register("report-polling", ReportPollingController);

import PresentationController from "./presentation_controller";
application.register("presentation", PresentationController);

import GeneratingStepsController from "./generating_steps_controller";
application.register("generating-steps", GeneratingStepsController);

import ExplainerController from "./explainer_controller";
application.register("explainer", ExplainerController);


import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import AccountConnectionsController from "./account_connections_controller";
application.register("account-connections", AccountConnectionsController);
